export default "__VITE_ASSET__9b8419b0__"